module.exports = __webpack_public_path__ + "static/media/blog2_2.a68cb18f.webp";